import { defineComponent } from 'vue-demi';
import { p as pxToRem } from './px-to-rem-0b26b83e.js';
import { openBlock, createElementBlock, normalizeClass, normalizeStyle } from 'vue';
import { s as styleInject } from './style-inject.es-4c6f2515.js';

var script = defineComponent({
  name: 'OrSkeletonRect',
  props: {
    isAnimated: {
      type: Boolean,
      required: false,
      default: false
    },
    width: {
      type: [Number, String],
      required: false,
      default: '100%'
    },
    height: {
      type: [Number, String],
      required: false,
      default: 36
    }
  },
  computed: {
    rootClasses() {
      return {
        'is-animated': this.isAnimated
      };
    },
    rootStyle() {
      var _a, _b;
      const width = (_a = this.width) !== null && _a !== void 0 ? _a : '100%';
      const height = (_b = this.height) !== null && _b !== void 0 ? _b : 36; // 36px - default OrInput height
      return {
        'width': typeof width === 'number' ? pxToRem(width) : width,
        'height': typeof height === 'number' ? pxToRem(height) : height
      };
    }
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["or-skeleton or-skeleton-rect", _ctx.rootClasses]),
    style: normalizeStyle(_ctx.rootStyle)
  }, null, 6 /* CLASS, STYLE */);
}

var css_248z = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-f965709e {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-f965709e {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-f965709e {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-f965709e {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n@keyframes wave-f965709e {\n0% {\n    transform: translateX(-100%);\n}\n100% {\n    transform: translateX(100%);\n}\n}\n.or-skeleton[data-v-f965709e] {\n  overflow: hidden;\n  position: relative;\n  padding: 0;\n  background: #f6f8fd;\n  border: 0;\n}\n.or-skeleton.is-animated[data-v-f965709e]::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  background: linear-gradient(90.14deg, #f6f8fd 0.1%, #fff 49.98%, #f6f8fd 99.06%);\n  animation: wave-f965709e 1.5s linear 0.5s infinite;\n}\n[data-theme=dark] .or-skeleton[data-v-f965709e] {\n  background: var(--c-neutral-3);\n}\n[data-theme=dark] .or-skeleton.is-animated[data-v-f965709e]::before {\n  background: linear-gradient(90.14deg, var(--c-neutral-3) 0.1%, var(--c-neutral-2) 49.98%, var(--c-neutral-3) 99.06%);\n}\n.or-skeleton-rect[data-v-f965709e] {\n  border-radius: var(--s-2);\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-f965709e";
script.__file = "src/components/or-skeleton/or-skeleton-rect/OrSkeletonRect.vue";

export { script as s };
